<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-treats-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-treats-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-treats-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('treat')
    }
  },
  methods: {
    ...mapMutations([
      'selectTreatStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectTreatStatus(1);
      this.goToItem('treat');
    },
    chooseMedium: function () {
      this.selectTreatStatus(2);
      this.goToItem('treat');
    },
    chooseTop: function () {
      this.selectTreatStatus(3);
      this.goToItem('treat');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-treats-basic {
  background-image: url('../../assets/questions/treat-minimum.jpg');
}
.lt-fyf-answer-treats-medium {
  background-image: url('../../assets/questions/treat-moderate.jpg');
}
.lt-fyf-answer-treats-top {
  background-image: url('../../assets/questions/treat-comfortable.jpg');
}
</style>